// L-10: allow the backend URL to be configured at build time instead of being
// hardcoded; hostname-based values remain as development fallbacks.
var _BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

if (!_BACKEND_URL) {
    if (window.location.hostname === "localhost") {
        _BACKEND_URL = "http://localhost:8080";
    } else if (window.location.hostname === "192.168.178.77") {
        _BACKEND_URL = "http://192.168.178.77:8080";
    } else {
        _BACKEND_URL = "https://qdex-backend.bubbly.games";
    }
}

export const BACKEND_URL = _BACKEND_URL;
